import axios from "axios";

const API_BASE_URL = "https://api.easyph.com.co/api";

export interface InformacionGeneral {
  ige_codigo: number;
  ige_titulo: string;
  ige_descripcion: string;
  ige_fecha: string;
  ige_activa: number;
  ige_activa_texto: string;
  ige_tipo_archivo: string;
  ige_ruta_archivo: string;
  ige_archivo_esta_cargado: string;
  ige_unidad_residencial: string;
}

export interface ObtenerTodosRequest {
  unidad_residencial_codigo: string;
  codigo: string;
  activa: string;
}

export interface ApiResponse<T> {
  code: string;
  message: string;
  object_: T;
}

export interface ModificarInformacionGeneralRequest {
  codigo: string;
  titulo: string;
  descripcion: string;
  activa: string;
}

export interface InsertarInformacionGeneralRequest {
  unidad_residencial_codigo: string;
  titulo: string;
  descripcion: string;
}

export interface InsertarArchivoRequest {
  iga_informacion_general: string;
  iga_archivo: File;
}

/**
 * Obtiene todos los registros de información general para una unidad residencial.
 */
export const obtenerTodosInformacionGeneral = async (
  payload: ObtenerTodosRequest
): Promise<ApiResponse<InformacionGeneral[]>> => {
  try {
    const response = await axios.post<ApiResponse<InformacionGeneral[]>>(
      `${API_BASE_URL}/informacion_general/ObtenerTodos`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener información general:", error);
    throw error;
  }
};

/**
 * Inserta un nuevo registro de información general.
 */
export const insertarInformacionGeneral = async (
  payload: InsertarInformacionGeneralRequest
): Promise<ApiResponse<InformacionGeneral[]>> => {
  try {
    const response = await axios.post<ApiResponse<InformacionGeneral[]>>(
      `${API_BASE_URL}/informacion_general/Insertar`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error al insertar información general:", error);
    throw error;
  }
};

/**
 * Modifica un registro de información general.
 */
export const modificarInformacionGeneral = async (
  payload: ModificarInformacionGeneralRequest
): Promise<ApiResponse<any>> => {
  try {
    const response = await axios.post<ApiResponse<any>>(
      `${API_BASE_URL}/informacion_general/Modificar`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error al modificar información general:", error);
    throw error;
  }
};

/**
 * Inserta un nuevo archivo para un registro de información general.
 */
export const insertarArchivoInformacionGeneral = async (
  payload: InsertarArchivoRequest
): Promise<ApiResponse<any>> => {
  try {
    const formData = new FormData();
    formData.append("iga_informacion_general", payload.iga_informacion_general);
    formData.append("iga_archivo", payload.iga_archivo);

    const response = await axios.post<ApiResponse<any>>(
      `${API_BASE_URL}/informacion_general_archivo/InsertarArchivos`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al subir archivo de información general:", error);
    throw error;
  }
};
